module.exports = __webpack_public_path__ + "img/message.662d1c30.svg";